export function apiSpinToMatrix(spin, { columns, rows }) {
    const matrix = [];

    for (let col = 0; col < columns; col++) {
        matrix[col] = [];
        for (let row = 0; row < rows; row++) {
            matrix[col][row] = spin[row][col];
        }
    }

    return matrix;
}

export function evaluatePaylines(matrix, {
    paylines,
    paytable,
    wild,
    scatter,
    bet,
}) {
    const wins = [];

    for (let lineIdx = 0; lineIdx < paylines.length; lineIdx++) {
        const line = paylines[lineIdx];
        const positions = line.map(([col, row]) => ({ col, row, symbol: matrix[col][row] }));

        let matchSymbol = null;
        for (const pos of positions) {
            if (pos.symbol !== wild && pos.symbol !== scatter) {
                matchSymbol = pos.symbol;
                break;
            }
        }
        if (!matchSymbol) continue;

        let count = 0;
        for (const pos of positions) {
            if (pos.symbol === matchSymbol || pos.symbol === wild) {
                count++;
            } else {
                break;
            }
        }

        if (count >= 3) {
            const payValue = paytable[matchSymbol]?.[count - 3] ?? 0;
            wins.push({
                lineIndex: lineIdx,
                symbol: matchSymbol,
                count,
                win: payValue * bet,
                positions: line.slice(0, count).map(([col, row]) => ({ col, row })),
            });
        }
    }

    return wins;
}
